<section id="fleet-billing-details">
    <h4><u>Fleet Billing Details:</u></h4>
    <p class="errormsg">{{errormsg}}</p>
    <p class="msg">{{msg}}</p>

    <table class="billingTable">
        <tr>
            <td class="billingTableLeftTD"><label>Billing Period: * </label></td>
            <td class="billingTableRightTD">
                @if(isButtonDisabled && !admin) {
                {{ transform(selectedBillingType) }}
                } @else {
                @for(type of billingType; track type) {
                <input type="radio" [value]="type" [(ngModel)]="selectedBillingType"> {{ transform(type) }}
                }
                }
            </td>
        </tr>
        @if(admin) {
        <tr>
            <td class="billingTableLeftTD"><label>Notes: </label></td>
            <td class="billingTableRightTD">
                <textarea class="input" id="notes" autocomplete="off" [(ngModel)]="fleetDetails.notes"></textarea>
            </td>
        </tr>
        }
        <tr>
            <td class="billingTableLeftTD"><label>Opt-In Date: * </label></td>
            <td class="billingTableRightTD">
                @if(isButtonDisabled && !admin) {
                <input type="date" class="input" readonly id="optInDate" autocomplete="off"
                    [(ngModel)]="fleetDetails.optInDate" />
                } @else {
                <input type="date" class="input" id="optInDate" autocomplete="off"
                    [(ngModel)]="fleetDetails.optInDate" />
                }
            </td>
        </tr>
        @if(selectedBillingType == "annual") {
        <tr>
            <td class="billingTableLeftTD"><label>Billing Terms: * </label></td>
            <td class="billingTableRightTD">
                @if(isButtonDisabled && !admin) {
                <input type="checkbox" id="agreement" [checked]="true" disabled>
                } @else {
                <input type="checkbox" id="agreement" readonly [(ngModel)]="agreementSelection" ]>
                } 
                I understand that once I select an annual billing period, I will not have the option to change the subscription count during that period.
            </td>
        </tr>
        }
        @if(isButtonDisabled && !admin) {
        } @else {
        <tr>
            <td colspan="2" align="right">* denotes a required field.</td>
        </tr>
        }
        @if(isButtonDisabled && !admin) {
        <tr>
            <td colspan="2">
                If you wish to OptOut of {{ transform(selectedBillingType) }} billing, please contact 1-800-ROTUNDA,
                (800-768-8632).
            </td>
        </tr>
        }        
        <tr>
            <td></td>
            <td align="right">
                @if(!isButtonDisabled) {
                <button id="updateButton" [disabled]="!selectedBillingType || !fleetDetails.optInDate"
                    (click)="updateDetails()">Update
                    Details</button>
                }
                @if(admin && isButtonDisabled) {
                <button id="updateButton" [disabled]="!selectedBillingType || !fleetDetails.optInDate"
                    (click)="updateDetails()">Update
                    Details</button>
                }
            </td>
        </tr>
    </table>
</section>